import { LazyRenderLayer } from 'core/layouts/ui-blocks/ReusableComponents';
import { ComponentLoadingScreen } from 'core/navigation/loading-screen/LoadingScreen';
import { homePageFaceReplaceModalSelector } from 'core/store/reducers/homeReducer/HomeSlice';
import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';

const FaceReplaceModal = lazy(() => import('./FaceReplaceModal'));

function LazyFaceReplaceModal() {
	const isModalOpen = useSelector(homePageFaceReplaceModalSelector);

	return (
		<LazyRenderLayer isShown={isModalOpen}>
			<Suspense fallback={<ComponentLoadingScreen />}>
				<FaceReplaceModal />
			</Suspense>
		</LazyRenderLayer>
	);
}

export default LazyFaceReplaceModal;
